import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Default from './layouts/Default.vue';
import Home from './views/Home.vue';
import Fichaje from './views/Fichaje.vue';
import Fichajev2 from './views/Fichajev2.vue';
import Tareas from './views/Tareas.vue';
import Historial from './views/Historial.vue';
import Contratos from './views/Contratos.vue';
import Chat from './views/Chat.vue';
import detalleTarea from './views/DetalleTarea.vue';
import detalleHistorial from './views/DetalleHistorial.vue';
import Contratosv2 from './views/Contratosv2.vue';
import Ubicacion from './views/verificaUbicacion.vue';

Vue.use(Router);
const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // {
    //   path: '/',
    //   component: Login,
    //   meta: { requiresAuth: false },
    //   name: 'Login',
    // },
    {
      path: '/',
      component: Ubicacion,
      meta: { requiresAuth: false },
      name: 'Login',
    },
    {
      path: '/Contratosv2/:id',
      name: 'Contratosv2',
      component: Contratosv2,
    },
    {
      path: '/fichajeV2',
      name: 'FichajeV2',
      component: Fichajev2,
    },
    {
      path: '/admin',
      component: Default,
      meta: { requiresAuth: true },
      children:
        [
          //   {
          //   path: 'blog-overview',
          //   name: 'blog-overview',
          //   component: PersonalBlog,
          // },
          {
            path: 'home',
            name: 'Home',
            meta: { rol: "1" },
            component: Home,
          },
          {
            path: 'fichaje',
            name: 'Fichaje',
            meta: { rol: "1" },
            component: Fichaje,
          },
          {
            path: 'Tareas',
            name: 'Tareas',
            meta: { rol: "1" },
            component: Tareas,
          },
          {
            path: 'Historial',
            name: 'Historial',
            meta: { rol: "1" },
            component: Historial,
          },
          {
            path: 'Contratos',
            name: 'Contratos',
            meta: { rol: "1" },
            component: Contratos,
          },
          {
            path: 'Chat',
            name: 'Chat',
            meta: { rol: "1" },
            component: Chat,
          },
          {
            path: 'detalleTarea',
            name: 'detalleTarea',
            meta: { rol: "1" },
            component: detalleTarea,
          },
          {
            path: 'detalleHistorial',
            name: 'detalleHistorial',
            meta: { rol: "1" },
            component: detalleHistorial,
          },
        ],
    },
    // {
    //   path: '*',
    //   redirect: '/login',
    // },
  ],
})

router.beforeEach((to, from, next) => {
  console.log('metas ------------->')
  const userRol = localStorage.getItem('rolUser')
  let metaRol = to.meta.rol
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (userRol && userRol > 0) {
      console.log(metaRol)
      console.log(metaRol.indexOf(userRol))

      if (metaRol && metaRol.indexOf(userRol) >= 0) {
        next()
      }
      else {
        next({ name: 'Login' })
      }
    }
    else {
      next({ name: 'Login' })
    }
  }
  else {
    next()
  }
})


export default router
